<template>
  <v-card class="sl_comments__block" flat>
    <comment-reply
        v-if="comment.comment_id"
        :has_cancel="false"
        :comment="comment.comment"
        @requestScrollTo="scrollToComment"
    />

    <v-card-text class="sl_comments__solo px-2 py-0 mb-1">
      <div class="sl_comments__reply--title sl_comments__reply--title_solo">
        <div class="d-flex">
          <v-btn color="sl_comments__button primary ml-0 mt-0 mr-3 mb-0" icon small>{{ comment.user | getText('short_name', 'N') }}</v-btn>
          <span class="body-2 sl_comments__reply--username">{{ comment.user | getText('name', 'N') }}</span>
          <div class="d-flex align-center">
            <span class="caption font-weight-light ml-3" style="line-height: 1">{{ comment.updated_at }}</span>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a @click="copyLink" v-on="on" class="ma-0 ml-2 d-flex align-center">
                  <v-icon  v-on="on" size="16">
                    {{ !isCopied ? 'link' : 'check'}}
                  </v-icon>
                </a>
              </template>
              <span>{{ isCopied ? 'Copied!' : 'Copy link to comment' }}</span>
            </v-tooltip>
          </div>
        </div>

        <div class="sl_comments__buttons">
          <a v-show="!comment.editing" @click="handleReply"><v-icon size="16">reply</v-icon> reply</a>
          <a v-show="comment.editing" @click="handleSave"><v-icon size="16">check</v-icon>save</a>
          <a v-show="!comment.editing && isUserAuthor" @click="comment.editing = true"><v-icon size="16">edit</v-icon>edit</a>
          <remove-dialog :yes="handleRemove">
            <a><v-icon size="16">delete</v-icon>delete</a>
          </remove-dialog>
        </div>
      </div>
      <div class="sl_comments__reply--body">
        <div class="sl_comments__reply--body__info">
          <markdown
            v-viewer
            v-model="comment.text"
            :editing="comment.editing"
          ></markdown>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import * as mixins from '@/mixins'
  import markdown from '@/components/markdown'
  import reply from '@/components/tasks/comments/reply'

  export default {
    name: 'CommentItem',
    props: ['comment'],
    mixins: [mixins.removable, mixins.user],
    data() {
      return {
        isCopied: false,
      }
    },
    methods: {
      handleRemove() {
        this.$emit('remove', this.comment)
      },
      handleSave() {
        this.$emit('save', this.comment)
      },
      handleReply() {
        this.$emit('reply', this.comment)
        this.$emit('requestScrollTo', 'comment-input', { block: 'end' });
      },
      scrollToComment(commentId) {
        this.$emit('requestScrollTo', commentId);
      },
      async copyLink() {
        this.isCopied = true;
        let href = window.location.href;
        const index = href.indexOf('?focusedCommentId');

        if (index !== -1) {
          href = href.slice(0, index);
        }

        await navigator.clipboard.writeText(`${href}?focusedCommentId=${this.comment.id}`);
        setTimeout(() => {
          this.isCopied = false;
        }, 500)
      }
    },
    computed: {
      isUserAuthor() {
        return this.comment.user_id === this.user.id
      }
    },
    components: {
      'comment-reply': reply,
      'markdown': markdown,
    }
  }
</script>
